import { atom } from "jotai";

export const ctxMenuAtom = atom<string | null>(null as string | null);
